var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBx24(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 38,
    viewBox: "0 0 87 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.107 11.0572C19.107 7.84719 16.406 6.72019 13.532 6.72019C9.682 6.72019 6.521 7.95919 3.591 9.25519L1.57899 3.34019C4.85499 1.87619 9.395 0.242188 14.797 0.242188C23.244 0.242188 27.324 4.41019 27.324 10.2682C27.324 20.5202 12.958 23.3922 10.544 31.2222H27.841V37.7562H0.315002C1.867 19.4502 19.107 18.3802 19.107 11.0572V11.0572Z",
    fill: "#0065A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.967 22.7166H43.415V18.7166C43.415 15.8456 43.645 12.5216 43.76 11.7896L35.197 22.8856C35.887 22.8296 38.645 22.7166 39.967 22.7166V22.7166ZM26.462 24.0126L45.426 0.354578H51.058V22.7166H56.69V28.9126H51.058V37.7556H43.415V28.9126H26.462V24.0126ZM73.618 22.2006C68.167 22.2006 63.748 17.8556 63.748 12.4956C63.748 7.13558 68.167 2.79058 73.618 2.79058C79.069 2.79058 83.488 7.13558 83.488 12.4956C83.488 17.8556 79.069 22.2006 73.618 22.2006ZM73.618 0.0175781C66.61 0.0175781 60.929 5.60358 60.929 12.4956C60.929 19.3866 66.61 24.9736 73.618 24.9736C80.626 24.9736 86.308 19.3866 86.308 12.4956C86.308 5.60358 80.626 0.0175781 73.618 0.0175781Z",
    fill: "#0065A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.028 6.95022V11.1092H79.258V13.8822H72.208V6.94922H75.028V6.95022Z",
    fill: "#0065A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBx24);
export default __webpack_public_path__ + "static/media/bx24.41693cda0700932175b9b9e54fabb316.svg";
export { ForwardRef as ReactComponent };